export default {
	common: {
		close: "Fermer",
	},
	checkout: {
		steps: {
			cart: "Panier",
			addresses: "Adresses",
			delivery: "Livraison",
			offer: "Offre",
		},
		back: "Retour",
		next: "Suivant",
		cartWarning: {
			line1: "Certains articles de ce panier sont actuellement en cours de blexonisation, n'ont pas encore été blexonisés avec la dernière version, ou leur prix a changé et n'a pas encore été recalculé.",
			line2: "Veuillez recalculer les articles ou contacter notre support en cas de questions.",
		},
		deliveryAddressTitle: "Adresse de livraison",
		invoiceAddressTitle: "Adresse de facturation",
		moreAddresses: "Autres adresses...",
		paymentType: {
			title: "Mode de paiement",
			text: "Nous vous enverrons une facture {method} à {email}.",
			digitalMethod: "par voie électronique",
			postalMethod: "par courrier postal",
			changeAddressTooltip: "Accède aux paramètres d'adresse.",
			changeAddress: "Modifier l'adresse",
		},
		orderNumberCard: {
			title: "Numéro de commande",
			description: "Vous pouvez attribuer votre propre numéro de commande pour cette commande.",
			description2: "Nous mentionnerons ce numéro sur le bon de livraison et la facture.",
			placeholder: "Votre numéro de commande",
		},
		notificationsCard: {
			title: "Notifications",
			description:
				"Nous envoyons la confirmation de commande ainsi que la notification de finalisation de votre commande à votre adresse e-mail ({email}). Ces messages peuvent également être envoyés à une adresse e-mail supplémentaire. Une valeur par défaut pour cette adresse e-mail peut être définie dans les {link}.",
			settingsLink: "paramètres du compte client",
			additionalEmailCheckbox: "Envoyer les messages à une adresse supplémentaire",
			additionalEmailPlaceholder: "Adresse e-mail",
		},
		addressPicker: {
			title: "Sélectionner l'adresse pour la commande",
		},
	},
	offer: {
		pleaseSelect: "Veuillez sélectionner",
		currentlyUnavailable: "Actuellement indisponible",
		fastDelivery: "Livraison rapide",
		bestPrice: "Meilleur prix",
		downloadPdfTooltip: "Télécharger l'offre au format PDF",
		table: {
			position: "Position",
			price: "Prix",
			deliveryDate: "Date de livraison (départ usine)",
			noDatesAvailable: "Aucune date de livraison disponible",
			positionsInCartPlural: "{count} positions dans le panier",
			positionsInCartSingular: "Position dans le panier",
			orderDiscount: "Remise sur commande",
			packagingAndDelivery: "Emballage & livraison {type}",
			accordingToEffort: "selon l'effort",
			invoiceByPost: "Facture par courrier postal",
			net: "Net",
			vat: "TVA ({ratio}%)",
			total: "Total (TVA incluse)",
		},
		acceptNachAufwand:
			"Je suis conscient(e) que des coûts supplémentaires pour l'emballage & la livraison seront engendrés",
		acceptAgb: "J'accepte les {agb}",
		buyNowTooltip: "Commander cette offre de manière définitive et payante",
		buyNow: "Acheter maintenant",
		requestOrderTooltip:
			"La commande sera transmise à la personne responsable de votre organisation pour validation.",
		requestOrder: "Demander la commande",
		errors: {
			timerExpired: "Le délai de validité de l'offre est écoulé",
			offerInvalid:
				"L'offre n'est plus valable car un article du panier a été modifié. Veuillez recalculer l'offre.",
			agbNotAccepted: "Les conditions générales doivent être acceptées",
			nachAufwandNotAccepted: "Les frais de livraison selon l'effort doivent être acceptés",
			noDeliveryDate: "Une date de livraison doit être sélectionnée",
			manufacturerNotAvailable:
				"Cette offre n'est pas disponible pour un retrait sur rampe à l'endroit sélectionné. Veuillez choisir un autre lieu de retrait ou de livraison.",
		},
		or: "ou",
		emailOrderTooltip:
			"Utilisez cette option si vous préférez commander par e-mail (par exemple depuis un système ERP/SAP).",
		emailOrder: "Enregistrer l'offre (commande par e-mail)",
		emailOrderHint:
			"L'offre est téléchargée sous forme de document PDF. Pour passer une commande, veuillez nous envoyer le document PDF par e-mail, par exemple en pièce jointe d'une commande ERP/SAP.",
		discountDialog: {
			title: "Quand est-ce que je reçois une remise sur commande ?",
			intro: "Lors du calcul d'une offre, toutes les positions qu'elle contient sont prises en compte et une remise sur commande est calculée.",
			factorsIntro: "Les facteurs suivants entraînent une {reduction}",
			priceReduction: "réduction de prix :",
			factor1: "Plusieurs articles issus de la même matière première (même matériau et même épaisseur de tôle)",
			factor2: "Plusieurs articles avec les mêmes usinages (filetages, fraisages et emboutissages) dans la même matière première",
			factor3: "Plusieurs articles avec le même revêtement poudre (même poudre)",
			factor4: "Plusieurs articles avec la même galvanisation",
		},
		nachAufwandDialog: {
			title: "Transport selon l'effort",
			text1: "Nous calculons automatiquement, dans la mesure du possible, les coûts d'emballage et d'expédition par courrier postal ou par camion.",
			text1b: "Nous renonçons délibérément à l'expédition d'objets encombrants par courrier postal, car l'effort d'emballage pour ce mode d'expédition est généralement disproportionné.",
			text1c: "Les pièces grandes et/ou lourdes sont livrées par camion. Dans ce cas, un calcul automatique à l'avance n'est pas toujours possible.",
			text2: "Le prix dépend de l'effort d'emballage, de la distance jusqu'au lieu de livraison, du poids des pièces et des dimensions de toutes les pièces de l'ensemble de la livraison.",
			text2b: "Pour les pièces de grande taille (plus grandes qu'une palette Europe), les dimensions ont un impact important sur le prix. La livraison devient plus chère à chaque centimètre supplémentaire. Il est en outre très difficile de calculer automatiquement comment les pièces pliées peuvent être empilées et quel emballage est nécessaire pour garantir un transport sûr.",
			text3Bold:
				"Pour les livraisons selon l'effort, nous vous facturons donc le montant réel facturé par notre transporteur selon le tarif ASTAG. Nous facturons en outre le temps d'emballage à la minute près.",
			text3: "Vous pouvez partir du principe qu'une livraison par camion selon l'effort coûte généralement entre {currency} 100.- et 200.-.",
			text3b: "Pour les envois très volumineux, par exemple plusieurs palettes Europe ou des envois de grande surface (longueur x largeur > 200 cm x 100 cm), le prix peut être plus élevé. En cas de doute, contactez notre support à l'adresse {email}",
			text4: "Nous sommes conscients qu'il est important pour nos clients de connaître le prix final, y compris tous les frais, avant de passer commande. Des limitations techniques rendent cela actuellement impossible dans certains cas. Nous avons délibérément renoncé à un tarif forfaitaire, car nous sommes convaincus que cette solution est plus transparente et plus économique et reflète mieux la réalité.",
		},
		orderFailedDialog: {
			title: "Échec de la commande",
			text: "Une erreur s'est produite lors du processus de commande.",
			text2: "Pour obtenir de l'aide, contactez notre support à l'adresse {email}",
		},
	},
	offerInformation: {
		calculating: "Votre offre est en cours de calcul...",
		calculatingHint: "Les frais et délais de livraison sont déterminés avec les partenaires de fabrication.",
		calculatingHint2: "Pour un grand nombre de positions, cela peut prendre une à deux minutes.",
		thanksForRequestTitle: "Merci pour votre demande.",
		manualOfferRequestedText:
			"Nous avons bien reçu votre demande et vous soumettrons une offre spécifique à votre commande. Nous vous remercions de votre patience durant son traitement. Dès que l'offre sera disponible, nous vous en informerons par e-mail.",
		thanksForOrderTitle: "Merci pour votre commande.",
		orderedDirectlyText:
			"Vous pouvez désormais consulter le statut de la commande dans l'aperçu des commandes. Vous recevrez également prochainement un e-mail de confirmation.",
		thanksForOrderTitle2: "Merci pour votre commande.",
		orderedIndirectlyText:
			"Les personnes responsables de votre organisation seront informées prochainement par e-mail de votre commande. Ces personnes peuvent, si nécessaire, l'ajuster puis la valider. Dès que votre besoin aura été commandé, vous pourrez consulter le statut de la commande dans l'aperçu des commandes. Vous recevrez également un e-mail de confirmation à ce moment-là.",
		backToArticlesTooltip: "Accède au catalogue d'articles.",
		backToArticles: "Vers mes articles",
		offerSavedTitle: "Merci pour votre demande.",
		offerSavedText: "Le PDF de votre offre a été téléchargé avec succès.",
		offerSavedText2:
			"Si vous souhaitez accepter notre offre, veuillez nous envoyer le PDF par e-mail à {email}.",
		offerSavedText3:
			"Si vous transmettez votre commande via un système ERP ou SAP, nous vous prions également de joindre le document PDF.",
		offerSavedText4: "Cela nous permet de traiter votre demande rapidement et efficacement.",
		countryNotServiced: "Offre impossible",
		countryNotServicedText: "Malheureusement, nous ne livrons pas encore de clients dans votre pays.",
		countryNotServicedText2: "Dès que cela changera, nous vous en informerons par notre newsletter.",
		noFertigerCanProduce:
			"Toutes les positions du panier ne peuvent pas être produites en un seul et même endroit,",
		noFertigerCanProduce2: "car certaines matières premières et/ou certains usinages s'excluent mutuellement.",
		noFertigerCanProduce3:
			"En règle générale, la commande peut être fabriquée si les positions sont réparties en conséquence.",
		noFertigerCanProduce4:
			"Si vous avez besoin d'aide, cliquez sur le bouton ci-dessous pour informer notre support.",
		noFertigerHasDeliveryDate:
			"En raison d'une charge de travail élevée ou d'une quantité de commande très importante, aucune date de livraison n'a pu être trouvée pour votre commande.",
		noFertigerHasDeliveryDate2:
			"Cliquez sur le bouton ci-dessous si vous souhaitez recevoir une offre pour la quantité demandée.",
		genericFailed: "L'offre n'a pas pu être créée.",
		genericFailed2:
			"Malheureusement, une erreur s'est produite lors de la création de votre offre. Veuillez réessayer.",
		genericFailed3: "Si l'erreur persiste, veuillez nous en informer à l'aide du bouton ci-dessous.",
		notifyHelpdeskTooltip: "Informer le support Blexon",
		notifyHelpdesk: "Informer le support",
		offerValidPlural:
			"Vos offres sont valables 15 minutes. Une fois ce délai écoulé, vous pouvez lancer un nouveau calcul.",
		offerValidSingular:
			"Votre offre est valable 15 minutes. Une fois ce délai écoulé, vous pouvez lancer un nouveau calcul.",
		recalculate: "Recalculer",
		helpdeskDialog: {
			title: "Informer le support Blexon",
			text: "Notre support sera informé de la situation et vous recontactera dès que possible à l'adresse suivante.",
			emailLabel: "E-mail pour les notifications",
			cancelTooltip: "Annuler l'action",
			okButton: "Ok",
			okTooltip: "Informer le support",
		},
		messages: {
			helpdeskInformed: "Le support a été informé.",
			helpdeskInformError: "Le support n'a pas pu être informé.",
		},
	},
	delivery: {
		title: "Mode de livraison",
		question: "Par quel moyen souhaitez-vous recevoir les pièces en tôle ?",
		producedBy: "Fabriqué par : {name}",
		deliveryOption: "Livré (1-2 jours à partir de la date de livraison)",
		rampeOption: "Retrait sur rampe (non emballé)",
		fertigerLoadError: "Les fabricants n'ont pas pu être chargés.",
		selectionRequired: "Veuillez sélectionner un lieu pour le retrait sur rampe.",
		addressDialog: {
			title: "Adresse pour le retrait sur rampe",
			phoneLabel: "Tél. :",
		},
		notPossibleDialog: {
			title: "Retrait sur rampe impossible",
			text: "Malheureusement, le retrait de cette commande n'est pas possible chez ce partenaire de fabrication. Il se peut que ce partenaire de fabrication ne propose pas le retrait sur rampe, ou qu'un matériau ou un usinage ne soit pas disponible.",
		},
	},
	summary: {
		chooseOffer: "Choisissez votre offre",
		yourOffer: "Votre offre",
	},
	manualOffer: {
		title: "{bold} Fabrication automatisée & remises de quantité attractives",
		titleBold: "Profitez-en maintenant :",
		intro: "Votre panier contient des quantités et/ou des matériaux qui vous donnent droit à une {discount}.",
		discountHighlight: "remise de quantité",
		text2: "Pour des séries plus importantes, l'achat de matière première peut être organisé plus efficacement et la fabrication automatisée {savings}",
		savingsHighlight: "– ce qui réduit nettement les coûts !",
		text3: "Notre partenaire de fabrication examine votre demande sous 1 à 2 jours ouvrables et vous soumet une offre de remise de quantité individuelle, adaptée à vos souhaits.",
		text4: "Règle générale : plus vous nous laissez de temps pour la production, plus la remise de quantité est attractive.",
		callToAction: "Demandez une offre dès maintenant et profitez-en !",
		chooseDeliveryDate: "Veuillez choisir la date de livraison la plus tardive (départ usine).",
		deliveryDateLabel: "Date de livraison la plus tardive",
		noDatesAvailable: "Aucune date de livraison disponible",
		requestOfferTooltip: "Demander une offre",
		requestOffer: "Demander une offre",
		restrictionHint: "Ce choix n'est possible qu'en cas de livraison ou de retrait sur rampe à {town}.",
	},
};
